import {Customer} from "../../../model/customer/customer";
import {Injectable} from "@angular/core";
import {Trader} from "../../../model/customer/trader";
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {BrokerageTable} from "../../../model/customer/brokerage-table";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {MoneyOwner} from "../../../model/customer/money-owner";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {AccountType} from "../../../model/exchange/account-type";
import {StringUtils} from "../../../utils/stringUtils";
import {AccountComponent} from "../../../crystal-clear/customer/account/account.component";
import {TranslateService} from "@ngx-translate/core";
import {CommonFieldService} from "../../common/common-field.service";
import {FieldsService} from "../../common/fields-service";

@Injectable({
  providedIn: 'root'
})
export class CustomerAccountDataLoadingService {

  owners: FieldRecord<any>[] = [];

  customers: FieldRecord<Customer>[] = [];
  displayedCustomers: FieldRecord<any>[] = [];

  clearingHouses: FieldRecord<any>[] = [];

  exchangeCodes: FieldRecord<ExchangeDetail>[] = [];
  displayedExchangeCodes: FieldRecord<any>[] = [];

  accountTypes: FieldRecord<any>[] = [];
  displayedAccountTypes: FieldRecord<any>[] = [];
  displayedGUpAccountTypes: FieldRecord<any>[] = [];

  brokerageTables: FieldRecord<BrokerageTable>[] = [];
  brokerageTablesVisibles: FieldRecord<BrokerageTable>[] = [];

  moneyOwners: FieldRecord<MoneyOwner>[] = [];
  moneyOwnersVisibles: FieldRecord<MoneyOwner>[] = [];

  traders: FieldRecord<Trader>[] = [];

  openCloses: FieldRecord<any>[] = [];

  constructor(readonly commonFieldService: CommonFieldService,
              readonly fieldsService: FieldsService,
              readonly translateService: TranslateService) {
  }

  loadData(component: AccountComponent) {
    this.openCloses = Object.keys(AccountDefinition.OpenClose).map(key => new FieldRecord(key, StringUtils.humanize(key)));

    this.fieldsService.loadField(this.owners, () => this.commonFieldService.getOwners(FieldRequest.DEFAULT()), component.tracker, (records) => {
      if (records?.length) {
        component.newRecord.owner = records[0].text;
        if (component.formRecord) {
          component.formRecord.owner = records[0].text;
          this.filterCustomers(component.formRecord);
        }
      }
    });

    this.fieldsService.loadField(this.customers, () => this.commonFieldService.getCustomers(FieldRequest.DEFAULT()), component.tracker, (records) => {
      this.filterCustomers(component.formRecord);
    });

    this.fieldsService.loadField(this.clearingHouses, () => this.commonFieldService.getClearingHouses(FieldRequest.DEFAULT()), component.tracker, (records) => {
      this.filterExchanges(component.formRecord);
      this.filterAccountType(component.formRecord);
    });

    this.fieldsService.loadField(this.accountTypes, () => this.commonFieldService.getAccountTypes(FieldRequest.DEFAULT()), component.tracker, (records) => {
      this.filterExchanges(component.formRecord);
      this.filterAccountType(component.formRecord);
    });
    this.fieldsService.loadField(this.exchangeCodes, () => this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()), component.tracker, (records) => {
      this.filterExchanges(component.formRecord);
      this.filterAccountType(component.formRecord);
    });
    this.fieldsService.loadField(this.traders, () => this.commonFieldService.getTraders(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.moneyOwners, () => this.commonFieldService.getMoneyOwner(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.brokerageTables, () => this.commonFieldService.getBrokerageTables(FieldRequest.DEFAULT()), component.tracker);
  }


  public refreshMoneyOwners(record: AccountDefinition) {
    this.moneyOwnersVisibles = this.moneyOwners.filter(value => value.value.owner === record.owner)
      .filter((value, index, self) =>
        index === self.findIndex((t) => t.value.code === value.value.code)
      );
  }

  refreshBrokerageTables(record: AccountDefinition) {
    this.brokerageTablesVisibles = this.brokerageTables.filter(value => value.value.ownerCode === record.owner)
      .filter((value, index, self) =>
        index === self.findIndex((t) => t.value.brokerageTableName === value.value.brokerageTableName)
      );
  }

  public filterExchanges(formRecord: AccountDefinition) {
    let defaultAllExchange = FieldRecord.DEFAULT();
    defaultAllExchange.text = this.translateService.instant('page.account.form.defaultExchangeAll');
    defaultAllExchange.id = ExchangeDetail.ALL;
    if (this.exchangeCodes && formRecord) {
      this.displayedExchangeCodes = this.exchangeCodes.filter(field =>
        field.id === ExchangeDetail.ALL || formRecord.clearingHouse === field.value.clearingHouse);
      this.displayedExchangeCodes.unshift(defaultAllExchange);
    } else {
      this.displayedExchangeCodes = [defaultAllExchange];
    }
  }

  public filterCustomers(formRecord: AccountDefinition) {
    if (this.customers && formRecord) {
      this.displayedCustomers = this.customers.filter(field => {
        return formRecord.owner === field.value.owner;
      });
      if(!this.displayedCustomers.find(customer => customer.value.id === formRecord.customerId)) {
        formRecord.customerName = undefined;
        formRecord.customerId = undefined;
      }
    } else {
      this.displayedCustomers = [];
    }
  }

  public filterAccountType(formRecord: AccountDefinition) {
    let defaultAllExchange = FieldRecord.DEFAULT();
    defaultAllExchange.text = this.translateService.instant('page.account.form.defaultAccountTypeGup');
    defaultAllExchange.id = AccountType.GIVE_UP_CODE;
    if (this.accountTypes && formRecord) {
      this.displayedAccountTypes = this.accountTypes.filter(field =>
        field.id === AccountType.GIVE_UP_CODE || (
          (formRecord.clearingHouse === field.value.clearingHouse
            && (!field.value.exchangeCode || field.value.exchangeCode.length === 0
              || field.value.exchangeCode === ExchangeDetail.ALL
              || field.value.exchangeCode === ExchangeDetail.ALL_TEXT
              || formRecord.exchangeCode === field.value.exchangeCode))));
      this.displayedGUpAccountTypes = [...this.displayedAccountTypes];
      this.displayedAccountTypes.unshift(defaultAllExchange);
    } else {
      this.displayedAccountTypes = [defaultAllExchange];
      this.displayedGUpAccountTypes = [];
    }
  }

}
